import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  InputAdornment,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  MenuItem,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useDeleteCustomerProjectMutation,
  useDeleteCustomerTransactionMutation,
  useGetAllInquiryQuery,
  useGetCustomerQuery,
  useGetCustomerTransactionQuery,
  useGetWorkOrderByCustomerProjectQuery,
  useRemovedCustomerProjectMMutation,
  useGetAllInvoiceQuery,
  useCreateEmailMutation, 
  useCreateCallMutation,
  useCreateTextMutation, 
  useCreateNoteMutation,
  useCreateNoteEmailMutation,
  useGetEmailTemplateQuery,
  useGetNoteTemplateQuery,
  useGetProjectActivityHistoryQuery,
  useGetInquiryActivityHistoryQuery,
  useGetDriverQuery,
} from "../../../Api/attoDeskApi";
import {
  ICustomer,
  IInquiry,
  ICustomerTransaction,
  IInvoice,
  IQuoteWorkOrder,
  IEmailTemplate,
  INoteTemplate,
  IActivityHistoryProjectApiResponse,
  ICall,
  IDriver,
} from "../../../Api/Interface/api.interface";
// import NewCustomerTransactionPopUp from "./Components/NewCustomerTransactionPopUp";
import { useNotifier } from "../../../Core/Notifier";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import DeletePopupMutaion from "../../../Components/Delete/DeletePopupMutaion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpCustomer from "../../Customer/Edit/index";
// import AddProject from "./Components/AddProject";
import dayjs from "dayjs";
import ReceiptIcon from "@mui/icons-material/Receipt";
// import AssignWorkOrder from "./Components/AssignWorkOrder";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InfoIcon from "@mui/icons-material/Info";
import CodeIcon from "@mui/icons-material/Code";
import HistoryIcon from "@mui/icons-material/History";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ChatIcon from "@mui/icons-material/Chat";
import NoteIcon from "@mui/icons-material/Note";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import NewCustomerTransactionPopUp from "../Components/NewCustomerTransactionPopUp";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  WorkOrderStatus, InquiryStatus
} from "../../../Core/Enum/enum";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import axios from "axios";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from "html2pdf.js";
import ViewInvoice from "../Components/ViewInvoice";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import moment from 'moment';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@mui/lab';

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const getProjectTypeLabel = (type: string): string => {
  const projectTypeMap: { [key in "1" | "2" | "3" | "4" | "5" | "6"]: string } = {
    "1": "Software Development",
    "2": "Website Design & Development",
    "3": "SEO",
    "4": "Mobile App",
    "5": "Flyers & Designs",
    "6": "Other",
  };

  return projectTypeMap[type as "1" | "2" | "3" | "4" | "5" | "6"] || "Unknown Project Type";
};

const getInquiryStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case InquiryStatus.New:
      return "New";
    case InquiryStatus.Contacted:
      return "Contacted";
    case InquiryStatus.FollowUp:
      return "Follow-up Required";
    case InquiryStatus.Converted:
      return "Converted";
    case InquiryStatus.Closed:
      return "Closed";
    default:
      return "Unknown Status";
  }
};


const steps = ["New", "Contacted", "Follow-up", "Converted", "Closed"];

const stepIcons = [
  <ContactSupportOutlinedIcon  sx={{ fontSize: 26 }} />,
  <PhoneOutlinedIcon  sx={{ fontSize: 26 }} />,
  <UpdateOutlinedIcon  sx={{ fontSize: 26 }} />,
  <ThumbUpOutlinedIcon  sx={{ fontSize: 26 }} />,
  <DoneOutlinedIcon  sx={{ fontSize: 26 }} />,
];




const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 32,
    
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#607d8b',
      borderColor: '#607d8b',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // backgroundColor: theme.palette.success.main,
      backgroundColor: '#607d8b',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 7,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
    marginLeft: '17px',  // half icon width
    marginRight: '17px',
  },
}));

const CustomStepLabel = styled(StepLabel)(() => ({
  "& .MuiStepLabel-iconContainer": {
    borderRadius: "50%",
    border: "2px solid",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
}));

const getInquiryStepIndex = (status: number) => {
  switch (status) {
    case InquiryStatus.New:
      return 0;
    case InquiryStatus.Contacted:
      return 1;
    case InquiryStatus.FollowUp:
      return 2;
    case InquiryStatus.Converted:
      return 3;
    case InquiryStatus.Closed:
      return 4;
    default:
      return 0;
  }
};

 const outcomeLabels: Record<string, string> = {
  interested: "Interested",
  not_interested: "Not Interested",
  call_later: "Call Later",
  converted: "Converted",
};

const capitalizeWords = (str: string | undefined | null): string => {
  if (!str) return "-";
  return str
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};




const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [searchQueryProject, setSearchQueryProject] = useState("");
  const [currentSearchQueryProject, setCurrentSearchQueryProject] =
    useState("");
  const debouncedSearchQueryProject = useDebounce(searchQueryProject, 300);

  const [searchQueryInvoice, setSearchQueryInvoice] = useState("");
  const [currentSearchQueryInvoice, setCurrentSearchQueryInvoice] =
    useState("");
  const debouncedSearchQueryInvoice = useDebounce(searchQueryInvoice, 300);

  const [searchQueryEmailTemplate, setSearchQueryEmailTemplate] = useState("");
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =
    useState("");
  const debouncedSearchQueryEmailTemplate = useDebounce(searchQueryEmailTemplate, 300);
  const [searchQueryNoteTemplate, setSearchQueryNoteTemplate] = useState("");
  const [currentSearchQueryNoteTemplate, setCurrentSearchQueryNoteTemplate] =
    useState("");
  const debouncedSearchQueryNoteTemplate = useDebounce(searchQueryNoteTemplate, 300);

  const { id: projectId } = useParams<{ id: string }>();
  const [selectCustomer, setSelectCustomer] = useState<ICustomer | null>(null);
  const [transactionData, setTransactionData] =
    useState<ICustomerTransaction>();

  const [deleteCategory] = useDeleteCustomerTransactionMutation();
  const [deleteProject] = useDeleteCustomerProjectMutation();

  const [openDialog, setOpenDialog] = useState(false);
  const [openAddTransaction, setOpenAddTransaction] = useState(false);
  const [openAddProject, setOpenAddProject] = useState(false);
  const [projectData, setProjecData] = useState<IInquiry>();

  const [openAddWorkOrder, setOpenAddWorkOrder] = useState(false);
  const [WorkOrderData, setWorkOrderData] = useState<IQuoteWorkOrder>();

  const { showErrorMessage, showMessage } = useNotifier();
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<ICustomerTransaction | null>(null);

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [projectToDelete, setProjectToDelete] =
    useState<IInquiry | null>(null);

  const [openDeleteProjectWrokOrder, setOpenDeleteProjectWrokOrder] =
    useState(false);
  const [projectWrokOrderToDelete, setProjectWrokOrderToDelete] =
    useState<IQuoteWorkOrder | null>(null);

  const [openProjectTable, setOpenProjectTable] = useState(false);
  const [projectIdByCustomer, setProjectByCustomerId] = useState<number>(0);
  const [projectName, setProjectName] = useState<string>("");
  const [expandedSteps, setExpandedSteps] = useState<number[]>([]);

  const [newNote, { isLoading: isNoteSaving }] = useCreateNoteMutation();
  const [newNoteEmail, { isLoading: isNoteEmailSaving }] = useCreateNoteEmailMutation();
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {}, [projectId]);

  const [showInfo, setShowInfo] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showTextForm, setShowTextForm] = useState(false);
  const [showNoteForm, setShowNoteForm] = useState(false);
  const [showCallForm, setShowCallForm] = useState(false);
  const [newEmail, { isLoading: isEmailSending }] = useCreateEmailMutation();
  const [newCall, { isLoading: isCallSending }] = useCreateCallMutation();
  const [newText, { isLoading: isTextSending }] = useCreateTextMutation();
  const [isSendAsEmail, setIsSendAsEmail] = useState(false);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [showEmailDialog, setShowEmailDialog] = useState(false);
    const [invoiceEmailData, setInvoiceEmailData] = useState({ to: '', template:'', subject: '', message: '' , attachments: [] });
    const invoiceRef = useRef<HTMLDivElement | null>(null);
    const [generatedAttachments, setGeneratedAttachments] = useState<File[]>([]);
    const [loading, setLoading] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;
    const [invoiceId, setInvoiceId] = useState("");
    const [callSummaryLog, setCallSummaryLog] = useState<ICall[]>([]); 

  const { data, isLoading, isError, refetch: inquiryRefetch, } = useGetAllInquiryQuery({
    searchText: "",
    customerId: "",
    id: String(projectId),
  });

  const project = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IInquiry;
    }
    return null;
  }, [data]);

  const {
    data: invoiceData,
    isLoading: invoiceIsLoading,
    isError: invoiceError,
    refetch: invoiceRefetch,
  } = useGetAllInvoiceQuery({
    searchText: currentSearchQueryInvoice,
    id: "",
    quoteWorkOrderCustomerId: String(project?.customer_id || ""),
    quoteWorkOrderCustomerProjectId: String(projectId),
  });

  const {
    data: customerTransactionData,
    isLoading: customerDataIsLoading,
    refetch,
  } = useGetCustomerTransactionQuery({
    searchText: currentSearchQuery,
    customerId: String(project?.customer_id || ""),
    projectId: String(projectId),
  });

  const {
    data: activityHistoryData,
    isLoading: activityHistoryIsLoading,
    refetch: refetchActivityHistory,
  } = useGetInquiryActivityHistoryQuery({
    searchText: "",
    customerId: String(project?.customer_id || ""),
    id: String(projectId),
  });

    const {
      data: driverData,
      isLoading: driverIsLoading,
      isError: driverError,
      refetch: driverRefetch,
    } = useGetDriverQuery({
      searchText: "",
      id: "",
      role: ["sales"],
    });

  const {
    data: workOrderProjectData,
    isLoading: workOrderProjectDataIsLoading,
    refetch: workOrderProjectRefetch,
  } = useGetWorkOrderByCustomerProjectQuery({
    searchText: "",
    quoteWorkOrderCustomerId: String(project?.customer_id || ""),
    quoteWorkOrderCustomerProjectId: String(projectId),
  });

  const {
    data: customerData,
    isLoading: customerIsloading,
    isError: customerIsError,
  } = useGetCustomerQuery({
    searchText: "",
    id: String(project?.customer_id || ""),
  });

  const {
    data: emailTemplateData,
    isLoading: emailTemplateIsLoading,
    isError: emailTemplateError,
    refetch: emailTemplateRefetch,
  } = useGetEmailTemplateQuery({
    searchText: currentSearchQueryEmailTemplate,
    // id: "",
  });

  const {
    data: noteTemplateData,
    isLoading: noteTemplateIsLoading,
    isError: noteTemplateError,
    refetch: noteTemplateRefetch,
  } = useGetNoteTemplateQuery({
    searchText: currentSearchQueryNoteTemplate,
    // id: "",
  });

  const customerList = useMemo(() => {
    if (
      customerData &&
      Array.isArray(customerData.data) &&
      customerData.data.length > 0
    ) {
      return customerData.data[0] as ICustomer;
    }
    return null;
  }, [customerData]);

  const transactions: ICustomerTransaction[] = useMemo(() => {
    if (
      customerTransactionData &&
      Array.isArray(customerTransactionData.data)
    ) {
      return customerTransactionData.data as ICustomerTransaction[];
    }
    return [];
  }, [customerTransactionData]);

  const workOrderProject: IQuoteWorkOrder[] = useMemo(() => {
    if (workOrderProjectData && Array.isArray(workOrderProjectData.data)) {
      return workOrderProjectData.data as IQuoteWorkOrder[];
    }
    return [];
  }, [workOrderProjectData]);

  const invoiceList: IInvoice[] = useMemo(() => {
    if (invoiceData && Array.isArray(invoiceData.data)) {
      return invoiceData.data as IInvoice[];
    }
    return [];
  }, [invoiceData]);

  const activityHistory = useMemo(() => {
    if (data && data.data) {
      return data as IActivityHistoryProjectApiResponse; // Cast the entire response to the expected type
    }
    return null;
  }, [data]);

  const emailTemplateList: IEmailTemplate[] = useMemo(() => {
    if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
      return emailTemplateData.data as IEmailTemplate[];
    }
    return [];
  }, [emailTemplateData]);

  const noteTemplateList: INoteTemplate[] = useMemo(() => {
    if (noteTemplateData && Array.isArray(noteTemplateData.data)) {
      return noteTemplateData.data as INoteTemplate[];
    }
    return [];
  }, [noteTemplateData]);

  const driverList: IDriver[] = useMemo(() => {
      if (driverData && Array.isArray(driverData.data)) {
        return driverData.data as IDriver[];
      }
      return [];
    }, [driverData]);
  

  const stripHtmlTags = (html: string) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  const emailFormik = useFormik({
    initialValues: {
      to: "",
      subject: "",
      message: "",
      template: "",
    },
    validate: (values) => {
      const errors: { [key: string]: string } = {};
      if (!values.to) {
        errors.to = "Email address is required";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.to)) {
        errors.to = "Invalid email address";
      }
     
      return errors;
    },
    onSubmit: async (values, { setValues  }) => {
      try {
        // Prepare the data to send via the newEmail API
        const emailData = {
          customer_id: project?.customer_id,
          project_id: projectId,
          to: values.to,
          subject: values.subject,
          message: values.message,
        };
  
        // Call the newEmail mutation API and wait for the response
        const emailResponse = await newEmail(emailData).unwrap();
        if (!emailResponse) {
          showErrorMessage("Failed to send email");
         // showErrorMessage(emailResponse.message);
        } else {
          showMessage("Email Sent successfully");
          const refetchResult = await refetchActivityHistory();
          setValues({
            ...values, // Preserve the "to" field
            subject: "", // Reset subject
            message: "", // Reset message
            template: "", // Reset template
          });
        }

      } catch (error) {
        showErrorMessage("Failed to send email");
      }
    },
  });

  const emailFormValid = useMemo(() => {
    return (
      emailFormik.values.to !== "" &&
      emailFormik.values.to !== undefined &&
      emailFormik.values.subject !== "" &&
      emailFormik.values.subject !== undefined &&
      stripHtmlTags(emailFormik.values.message) !=="" &&
      stripHtmlTags(emailFormik.values.message) !==undefined 
    );
  }, [emailFormik.values.to, emailFormik.values.subject, emailFormik.values.message]);

  const callFormik = useFormik({
  initialValues: {
    call_date: dayjs().format("YYYY-MM-DD"),
    notes: "",
    call_outcome: "",
    priority: "",
    next_follow_up_date: "",
     assigned_to: "", 
  },
   onSubmit: async (values, { resetForm  }) => {
      try {
        // Prepare the data to send via the newEmail API
        const callData = {
           call_date: values.call_date,
        notes: values.notes,
        call_outcome: values.call_outcome,
        priority: values.priority,
        next_follow_up_date: values.next_follow_up_date || null,
        assigned_to: values.assigned_to || null,
        customer_id: project?.customer_id,
        inquiry_id: projectId,
      };

      //      const addCompanyResponse = await axios.post(`${API_URL}/save-call`, callData, {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      //     "Content-Type": "application/json",
      //   },
      // });
      const addCompanyResponse = await newCall(callData).unwrap();

        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
        showMessage("Call summary saved successfully");
          inquiryRefetch();
         fetchCallSummaryLogs();
         await refetchActivityHistory();
         resetForm();
        }
      } catch (error) {
          console.error("Failed to save call summary", error); 
        showErrorMessage("Failed to save call summary");
      }
  
       
    },
  });

const callFormValid = useMemo(() => {
  const outcomeSelected = !!callFormik.values.call_outcome;

  // If outcome requires follow-up, ensure date is filled
  const followUpRequired = ["interested", "call_later"].includes(
    callFormik.values.call_outcome || ""
  );
  const followUpFilled = followUpRequired
    ? !!callFormik.values.next_follow_up_date
    : true;

  // Notes are optional, so no check for notes
  return outcomeSelected && followUpFilled;
}, [
  callFormik.values.call_outcome,
  callFormik.values.next_follow_up_date,
]); 

  const textFormik = useFormik({
    initialValues: {
      message: "",
    },
    
    onSubmit: async (values, { setValues  }) => {
      try {
        // Prepare the data to send via the newEmail API
        const textData = {
          customer_id: project?.customer_id,
          project_id: projectId,
          phone_no: project?.customer?.customerMobileNum || "",
          message: stripHtmlTags(values.message),
        };
  
        // Call the newEmail mutation API and wait for the response
        const textResponse = await newText(textData).unwrap();
        if (!textResponse) {
          showErrorMessage("Failed to send sms");
         // showErrorMessage(emailResponse.message);
        } else {
          showMessage("Sms Sent successfully");
          const refetchResult = await refetchActivityHistory();
          setValues({
            ...values, // Preserve the "to" field
            message: "", // Reset message
          });
        }

      } catch (error) {
        showErrorMessage("Failed to send email");
      }
    },
  });

  const textFormValid = useMemo(() => {
    return (
      stripHtmlTags(textFormik.values.message) !=="" &&
      stripHtmlTags(textFormik.values.message) !==undefined 
    );
  }, [textFormik.values.message]);





  const handleNoteEmailSubmit = async (values: any, resetForm: () => void) => {
    try {
    
      const noteEmailData = {
        customer_id: project?.customer_id,
        to: project?.customer?.customerEmail || "", // Assuming customer is available
        project_id: projectId,
        note_subject: values.subject,
        note_message: values.message,
      };
  
      // Call the send email API
      const emailResponse = await newNoteEmail(noteEmailData).unwrap();
      showMessage("Email Sent successfully");
      const refetchResult = await refetchActivityHistory();
      resetForm();
      setIsSendAsEmail(false);
    } catch (error) {
      showErrorMessage("Failed to send email");
    }
  };
  
  // Function to handle saving a note
  const handleNoteSaveSubmit = async (values: any, resetForm: () => void) => {
    try {
      
      const noteData = {
        customer_id: project?.customer_id,
        project_id: projectId,
        note_subject: values.subject,
        note_message: stripHtmlTags(values.message),
      };
  
      // Call the save note API
      const noteResponse = await newNote(noteData).unwrap();
      showMessage("Note saved successfully");
      const refetchResult = await refetchActivityHistory();
      resetForm(); // Reset the form on success
    } catch (error) {
      showErrorMessage("Failed to save note");
    } 
  };

  const noteFormik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
 
    onSubmit: async (values, { resetForm }) => {
      if (isSendAsEmail) {
        // Submit as email
        await handleNoteEmailSubmit(values, resetForm);
      } else {
        // Save as note
        await handleNoteSaveSubmit(values, resetForm);
      }
    },
  });

  const noteFormValid = useMemo(() => {
    return (
      // noteFormik.values.to !== "" &&
      // noteFormik.values.to !== undefined &&
      noteFormik.values.subject !== "" &&
      noteFormik.values.subject !== undefined &&
      stripHtmlTags(noteFormik.values.message) !=="" &&
      stripHtmlTags(noteFormik.values.message) !==undefined 
    );
  }, [noteFormik.values.subject, noteFormik.values.message]);


  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (
      debouncedSearchQueryProject.length >= 4 ||
      debouncedSearchQueryProject === ""
    ) {
      setCurrentSearchQueryProject(debouncedSearchQueryProject);
      refetch();
    }
  }, [debouncedSearchQueryProject]);

  useEffect(() => {
    if (
      debouncedSearchQueryInvoice.length >= 3 ||
      debouncedSearchQueryInvoice === ""
    ) {
      setCurrentSearchQueryInvoice(debouncedSearchQueryInvoice);
      refetch();
    }
  }, [debouncedSearchQueryInvoice]);

  useEffect(() => {
    if (project && project?.customer?.customerEmail ) {
      setInvoiceEmailData({ ...invoiceEmailData, to: project.customer?.customerEmail });
    }
  }, [project]);

  const fetchCallSummaryLogs = async () => {
  try {
    const response = await axios.get(`${API_URL}/view-call-summary`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      params: {
        inquiry_id: projectId, // Pass inquiry ID
      },
    });

    setCallSummaryLog(response.data.data); // Save data to state
  } catch (error) {
    console.error("Failed to load call summary", error);
  }
};


 useEffect(() => {
  fetchCallSummaryLogs(); // Initial load
}, []);


  const handleOpenDialog = (customer: ICustomer) => {
    setSelectCustomer(customer);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectCustomer(null);
    setOpenDialog(false);
  };

  const handleOpenAddTransaction = () => {
    setTransactionData(undefined);
    setOpenAddTransaction(true);
  };

  const handleCloseAddTransaction = () => {
    setTransactionData(undefined);
    setOpenAddTransaction(false);
  };

  const handleOpenAddProject = () => {
    setProjecData(undefined);
    setOpenAddProject(true);
  };

  const handleCloseAddProject = () => {
    setProjecData(undefined);
    setOpenAddProject(false);
  };

  const handleOpenAddWorkOrder = () => {
    setWorkOrderData(undefined);
    setOpenAddWorkOrder(true);
  };

  const handleCloseAddWorkOrder = () => {
    setWorkOrderData(undefined);
    setOpenAddWorkOrder(false);
  };

  const handleInfoToggle = () => {
    setShowInfo(true);
    setShowInvoice(false);
    setShowEmailForm(false); // Ensure email is hidden
    setShowNoteForm(false); 
    setShowTextForm(false);
    setShowCallForm(false);
  };

  const handleInvoiceToggle = () => {
    setShowInfo(false);
    setShowInvoice(true);
    setShowEmailForm(false); // Ensure email is hidden
    setShowNoteForm(false); 
    setShowTextForm(false);
    setShowCallForm(false);
  };

  // Toggle Email
  const handleEmailToggle = () => {

    setShowInvoice(false);
    setShowEmailForm(true);
     // Ensure project is hidden
    setShowNoteForm(false);
    setShowTextForm(false);
    setShowCallForm(false); 
      setShowInfo(false);
  };

  const handleTextToggle = () => {
    setShowInvoice(false);
    setShowEmailForm(false);
    setShowInfo(false); // Ensure project is hidden
    setShowNoteForm(false); 
    setShowTextForm(true); 
    setShowCallForm(false);
  };

  const handleNoteToggle = () => {
    setShowInvoice(false);
    setShowEmailForm(false);
    setShowInfo(false); // Ensure project is hidden
    setShowNoteForm(true); 
    setShowTextForm(false);
    setShowCallForm(false);
  };

    const handleCallToggle = () => {
    setShowInvoice(false);
    setShowEmailForm(false);
    setShowInfo(false); // Ensure project is hidden
    setShowNoteForm(false); 
    setShowTextForm(false);
    setShowCallForm(true);
  };

  
 

  if (isLoading || customerDataIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching customer data. Please try again later.
      </Typography>
    );
  }

  if (!project) {
    return <Typography>No customer data available.</Typography>;
  }
  const handleOpenDeletePopup = (coursing: ICustomerTransaction) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  const handleOpenDeleteProjectPopup = (project: IInquiry) => {
    setProjectToDelete(project);
    setOpenDeleteProject(true);
  };

  const handleCloseDeleteProjectPopup = () => {
    setProjectToDelete(null);
    setOpenDeleteProject(false);
  };

  const handleDeleteProject = async (id: string) => {
    try {
      const response = await deleteProject(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProject(false);
      } else {
        showErrorMessage("Failed to delete the customer project");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer project");
    }
  };

  const handleOpenDeleteWrokOrderPopup = (project: IQuoteWorkOrder) => {
    setProjectWrokOrderToDelete(project);
    setOpenDeleteProjectWrokOrder(true);
  };

  const handleCloseDeleteWrokOrderPopup = () => {
    setProjectWrokOrderToDelete(null);
    setOpenDeleteProjectWrokOrder(false);
  };

 

  const emailLogs = activityHistoryData?.data?.emailLogs || [];
  const smsLogs = activityHistoryData?.data?.smsLogs || [];
  const noteLogs = activityHistoryData?.data?.noteLogs || [];
  const notes = activityHistoryData?.data?.notes || [];
  const callSummaries = activityHistoryData?.data?.callSummaries || [];
  const inquiryLogs = activityHistoryData?.data?.inquiryLogs || [];

  const combinedLogs = [
  ...emailLogs.map((log) => ({ ...log, type: "Email Sent" })),
  ...smsLogs.map((log) => ({ ...log, type: "Sms Sent" })),
  ...noteLogs.map((log) => ({ ...log, type: "Note Email Sent" })),
  ...notes.map((log) => ({ ...log, type: "Note Saved" })),
  ...callSummaries.map((log) => ({
    ...log,
    type: "Call Summary Added",
    description: `Outcome: ${outcomeLabels[log.call_outcome] || "N/A"} | Notes: ${log.notes || "N/A"} | Priority: ${log.priority || "N/A"}`,
  })),
  // ...inquiryLogs.map((log) => ({
  //   ...log,
  //   type: "Inquiry Status",
  //   description: `Status changed to: ${log.status}`,
  // })),


 ...inquiryLogs
  .filter(log => log.action !== "call summary added")
  .map((log) => {
    let type = "Inquiry Created";

    if (log.action === "created") {
      type = "Inquiry Created";
    } else if (log.action === "updated") {
      type = "Inquiry Updated";
    } else if (log.action === "deleted") {
      type = "Inquiry Deleted";
    }
          return {
            ...log,
            type, // Use the determined type
          };
        }),
];


  const sortedCombinedLogs = combinedLogs.sort((a, b) => {
    const dateA = new Date(a.created_at).getTime();
    const dateB = new Date(b.created_at).getTime();
    return dateB - dateA; // Sort descending
  });
  
  const timeLineSteps = sortedCombinedLogs.map((log, index) => {
    let description;
  
    if (log.type === "Sms Sent") {
      description = `Message | ${log.message || 'N/A'}`; // Customize description for SMS
    } else if (log.type === "Call Summary Added") {
  description = `
    Outcome: ${outcomeLabels[log.call_outcome] || "N/A"}
    | Priority: ${log.priority || "N/A"}
    | Follow-up: ${log.next_follow_up_date || "None"}`;
    } else if (log.type.startsWith("Inquiry")) {
        
          if (log.type === "Inquiry Created") {
            description = `Inquiry has been created `;
              } else if (log.type === "Inquiry Status") {
            description = `Inquiry status changed to ${getInquiryStatusLabel(log.status)}`;
        } else if (log.type === "Inquiry Updated") {
            description = `Inquiry details have been updated`;
            } else if (log.type === "Call Summary") {
  description = `
    Outcome: ${log.call_outcome || "N/A"}
    | Priority: ${log.priority || "N/A"}
    | Follow-up: ${log.next_follow_up_date || "None"}
  `;

        } else if (log.type === "Inquiry Deleted") {
            description = `Inquiry has been deleted`;
        }  
       } else {
      description = `Subject | ${log.subject || 'No Subject'}`; // Default for emails and note emails
    }
  
    return {
      key: `${log.type}-${log.created_at}-${log.id || index}`,
      label: log.type,
      description, // Use the customized description
      date: new Date(log.created_at).toLocaleDateString(),
      time: new Date(log.created_at).toLocaleTimeString(),
    };
  });

  const toggleStepDetails = (index: number) => {
    if (expandedSteps.includes(index)) {
      setExpandedSteps(
        expandedSteps.filter((stepIndex) => stepIndex !== index)
      );
    } else {
      setExpandedSteps([...expandedSteps, index]);
    }
  };

  const convertPlainTextToHTML= (text: string) => {
    return text
      .replace(/\n/g, '<br>') // Replace line breaks with <br>
      .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length)); // Replace multiple spaces with &nbsp;
  }
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsSendAsEmail(event.target.checked); // Toggle the state when switch is changed
  };


  const handleSelectAllRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
        setSelectedRows(invoiceList.map((transaction) => transaction.id));
    } else {
        setSelectedRows([]);
    }
};

const handleEmailDialogOpen = async () => {

  
  setInvoiceEmailData(prevState => ({
    to: prevState.to, // Keep the 'to' value unchanged
    template: '',
    subject: '',
    message: '',
    attachments: [],
  }));

  try {
    const pdfAttachments: (File | null | undefined)[] = [];

    for (const selectedRowId of selectedRows) {
      const transaction = invoiceList.find((inv) => inv.id === selectedRowId);
      if (!transaction) {
        console.warn(`Invoice not found for ID: ${selectedRowId}`);
        continue;
      }

      const pdfBlob = await handleGeneratePDF2(transaction.id);
      if (!pdfBlob) {
        console.warn(`Failed to generate PDF for Invoice ID: ${selectedRowId}`);
        continue;
      }

      // Ensure pdfBlob is not undefined and is a valid Blob
      if (pdfBlob instanceof Blob) {
        const file = new File([pdfBlob], `Invoice-${transaction.InvoiceNo}.pdf`, {
          type: "application/pdf",
        });
        pdfAttachments.push(file);
      } else {
        console.warn(`Invalid Blob generated for Invoice ID: ${selectedRowId}`);
      }
    }

    // Save generated attachments to state
    setGeneratedAttachments(
      pdfAttachments.filter((attachment): attachment is File => Boolean(attachment))
    );
    console.log("Generated Attachments:", pdfAttachments);
    // Open the email dialog
    setShowEmailDialog(true);
  } catch (error) {
    console.error("Error opening email dialog:", error);
  }
};




const handleGeneratePDF2 = async (invoiceId: any): Promise<Blob | null> => {
  try {
    const invoice = invoiceList.find((inv) => inv.id === invoiceId);
    if (!invoice) {
      throw new Error(`Invoice not found for ID: ${invoiceId}`);
    }

    const invoiceContent = document.getElementById("invoice-content");
    if(invoiceContent)
    {
      invoiceContent.style.display = 'block';
    }

    if (!invoiceContent) {
      console.error(`Invoice content not found for Invoice ID: ${invoiceId}`);
    }

    const options = {
       margin: 1,
      filename: `Invoice_${invoiceId}.pdf`,
      image: { type: 'jpeg', quality: 0.8 }, // You can experiment with different qualities (0.8 for reduced size)
      html2canvas: {
        scale: 2, // Reduce scale for a lower resolution to make the PDF smaller
        useCORS: true, // Ensure that cross-origin images are handled properly
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

// Generate PDF Blob
const pdfBlob = await html2pdf().from(invoiceContent).set(options).outputPdf('blob');
// console.log('PDF Blob generated:', pdfBlob);

// // Download the generated PDF
// const pdfUrl = URL.createObjectURL(pdfBlob);


// const link = document.createElement('a');
// link.href = pdfUrl;
// link.download = `Invoice_${invoiceId}.pdf`;
// document.body.appendChild(link);

// Trigger the download
// link.click();

// Clean up
// document.body.removeChild(link);
// URL.revokeObjectURL(pdfUrl);
if(invoiceContent)
  {
invoiceContent.style.display = 'none';
  }
return pdfBlob;

    // const doc = new jsPDF({
    //   unit: 'mm',
    //   format: 'a4',
    //   orientation: 'portrait',
    //   compress: true, 
    // });
    // doc.html(invoiceContent, {
    //   callback: (doc) => {
    //     const pdfBlob = doc.output("blob");

    //     // Trigger the download of the PDF
    //     const url = URL.createObjectURL(pdfBlob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `Invoice-${invoiceId}.pdf`;
    //     link.click();

    //     // Clean up the URL after download
    //     URL.revokeObjectURL(url);

    //     // Resolve the Promise with the pdfBlob
    //     resolve(pdfBlob);
    //   },
    //   x: 10,
    //   y: 10,
    //   width: 200, // Scale to fit the page width
    //   windowWidth: 800, 
    // });
  } catch (error) {
    console.error(`Failed to generate PDF for Invoice ID: ${invoiceId}`, error);
    return null;
//reject(error);
  }
// });
};

  const handleEmailDialogClose = () => setShowEmailDialog(false);

  const handleSendEmail = async () => {
    setLoading(true);

    try {
        if (!generatedAttachments.length) {
            showErrorMessage("No PDFs generated to attach. Please try again.");
            return;
        }

        const customerFirstName = customerList?.customerFirstName || "Customer"; 
        const updatedMessage = invoiceEmailData.message.replace(/\[customer_name\]/g, customerFirstName);

        const emailData = {
            customer_id: project.customer_id ? parseInt(project.customer_id, 10) : 0,
            project_id: project.id ? project.id : 0,
            to: invoiceEmailData.to,
            subject: invoiceEmailData.subject,
           // message: invoiceEmailData.message,
            message: convertPlainTextToHTML(updatedMessage),
            attachments: generatedAttachments,
        };

        // Create FormData object
        const formData = new FormData();
        formData.append("customer_id", emailData.customer_id.toString());
        formData.append("project_id", emailData.project_id.toString());
        formData.append("to", emailData.to);
        formData.append("subject", emailData.subject);
        formData.append("message", emailData.message);

        emailData.attachments.forEach((file) => {
            formData.append("attachments[]", file);
        });

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        };

        const emailResponse = await axios.post(`${API_URL}/send-email`, formData, { headers });

        if (emailResponse) {
            setSelectedRows([]);
            showMessage("Email sent successfully");
            await refetchActivityHistory();
            setInvoiceEmailData({ ...invoiceEmailData, subject: "", message: "" });
        } else {
            showErrorMessage("Failed to send email");
        }
    } catch (error) {
        console.error("Error during email sending:", error);
        showErrorMessage("Failed to send email");
    } finally {
        handleEmailDialogClose();
        setLoading(false);
    }
};

 const handleSelectRow = async (id: number) => {
      // Update the selectedRows state by either adding or removing the row ID
      setSelectedRows((prevSelected) => {
        const updatedSelectedRows = prevSelected.includes(id)
          ? prevSelected.filter((rowId) => rowId !== id)
          : [...prevSelected, id];
    
        
        return updatedSelectedRows;
      });
    };
 


  return (
    <div>
      <Grid container spacing={3}>

      
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
  container
  direction="column"
  alignItems="center"
  justifyContent="center"
 // className={classes.profileBottomSetUp}
  
  sx={{
    position: 'relative',
    display: 'flex',
    justifyContent: "flex-start ",
    height: "auto",
    py: 4,
    textAlign: "center",
//    background: `
//   linear-gradient(
//       ${theme.palette.success.main} 250px,
//     #FFFFFF 250px
//   )
// `
background:'#607d8b',

  }}
>
  
      <Typography
        className={classes.cardTitle}
        style={{ color: "white",  textAlign: "center", marginBottom: "20px" }}
      >
        {project.message}
      </Typography>


      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 1.5,
           px: 2,
        }}
      >
        {project?.event_type && (
          <Button
            variant="outlined"
            size="small"
              sx={{
        // color: "success.main",  
        color: "#607d8b",         // success color text
        borderColor: "white",
        backgroundColor: "white",
        pointerEvents: "none",          // disables pointer / click
        "&:hover": {                     // disable hover effect
          backgroundColor: "white",
          borderColor: "white",
        },
      }}
    >
          
            {project.event_type}
          </Button>
        )}

        {project?.event_date && (
          <Button
            variant="outlined"
            size="small"
             sx={{
         color: "#607d8b",            // success color text
        borderColor: "white",
        backgroundColor: "white",
        pointerEvents: "none",          // disables pointer / click
        "&:hover": {                     // disable hover effect
          backgroundColor: "white",
          borderColor: "white",
        },
      }}
          >
            {dayjs(project.event_date).format("DD-MMM-YY")}
          </Button>
        )}

        {project?.estimated_guests && (
          <Button
            variant="outlined"
            size="small"
            sx={{
         color: "#607d8b",            // success color text
        borderColor: "white",
        backgroundColor: "white",
        pointerEvents: "none",          // disables pointer / click
        "&:hover": {                     // disable hover effect
          backgroundColor: "white",
          borderColor: "white",
        },
      }}
          >
            Est. Guest : {project.estimated_guests}
          </Button>
        )}

        {project?.budget_per_person && (
          <Button
            variant="outlined"
            size="small"
            sx={{
         color: "#607d8b",           // success color text
        borderColor: "white",
        backgroundColor: "white",
        pointerEvents: "none",          // disables pointer / click
        "&:hover": {                     // disable hover effect
          backgroundColor: "white",
          borderColor: "white",
        },
      }}
          >
            ${project.budget_per_person} Budget Per Person
          </Button>
        )}
      </Box>

  </Grid>

  <Grid item xs={12} sx={{ p: 3 }}>
    <Box sx={{ width: "100%", overflowX:"auto" }}>
   <Stepper
  activeStep={getInquiryStepIndex(project?.status ?? InquiryStatus.New)}
  alternativeLabel
  connector={<CustomStepConnector />}
     sx={{
      minWidth: "600px",
    }}
>
  {steps.map((label, index) => (
    <Step key={label}>
      <StepLabel
        StepIconComponent={(props) => {
          const { active, completed } = props;

          return (
            <Box
              sx={{
                width: '75px',
                height: '75px',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: active
                  ? "#607d8b" // highlight active step
                  : completed
                  ? "#607d8b"   // completed step
                  : theme.palette.grey[500],  // pending step
                color: "white",
                borderRadius: '15px',
              }}
            >
              {stepIcons[index] &&
                React.cloneElement(stepIcons[index], { sx: { fontSize: 26 } })}
            </Box>
          );
        }}
      >
        {label}
      </StepLabel>
    </Step>
  ))}
</Stepper>


    </Box>


  <Grid className={classes.profileDetails} sx={{ pt: 2 }}>
                    
                      <Grid className={classes.buttonGroup}>
                        {/* <div className={classes.buttonItem}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.editButtonProfile}
                            onClick={handleInfoToggle}
                          >
                            <InfoIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Info
                          </Typography>
                        </div>

                        <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                                onClick={handleInvoiceToggle}
                              >
                                <DescriptionIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Invoice
                              </Typography>
                            </div> */}
                        <div className={classes.buttonItem}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.editButtonProfile}
                            onClick={handleEmailToggle}
                          >
                            <EmailIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Email
                          </Typography>
                        </div>

                        <div className={classes.buttonItem}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.editButtonProfile}
                               onClick={handleCallToggle}
                              >   
                                <PhoneIcon />
                              </Button>
                              <Typography className={classes.buttonLabel}>
                                Call
                              </Typography>
                            </div>

                        <div className={classes.buttonItem}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.editButtonProfile}
                            onClick={handleTextToggle}
                          >
                            <ChatIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Text
                          </Typography>
                        </div>

                        {/* <div className={classes.buttonItem}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.editButtonProfile}
                            onClick={handleNoteToggle}
                          >
                            <NoteIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Note
                          </Typography>
                        </div> */}

                        {/* <div className={classes.buttonItem}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.editButtonProfile}
                          >
                            <HistoryIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            History
                          </Typography>
                        </div> */}
                      </Grid>
                    </Grid>


  </Grid>






</Card>
                

                  </Grid>

    
            
            {showInfo && 
            <>


             <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                <Card className={classes.stepperCard}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                                Call Summary History
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                       
{callSummaryLog && callSummaryLog.length > 0 ? (
  <Timeline
    position="right"
    sx={{
      px: 2,
      "& .MuiTimelineItem-root:before": {
        flex: 0,
        padding: 0,
      },
    }}
  >
    {callSummaryLog.map((log, index) => {
      const isOverdue =
        log.next_follow_up_date &&
        dayjs(log.next_follow_up_date).isBefore(dayjs(), "day");

      return (
      <TimelineItem
  key={log.id || index}
  // sx={{
  //   alignItems: "center",
  // }}
>
  {/* LEFT SIDE - CONTENT */}
  <TimelineContent sx={{ py: 1 }}>
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: "#fff",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        transition: "0.2s",
        "&:hover": {
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* Top Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
          {capitalizeWords(log.call_outcome) || "-"}
        </Typography>

        <Box
          sx={{
            px: 1.5,
            py: 0.3,
            borderRadius: "12px",
            fontSize: 11,
            fontWeight: 600,
            background:
              log.priority === "high"
                ? "rgba(244,67,54,0.12)"
                : "rgba(25,118,210,0.12)",
            color:
              log.priority === "high"
                ? "#d32f2f"
                : "#1976d2",
          }}
        >
          {log.priority?.toUpperCase() || "NORMAL"}
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ color: "text.secondary", fontSize: 13 }}
      >
        {log.notes || "-"}
      </Typography>

      {log.next_follow_up_date && (
        <Box
          sx={{
            mt: 1,
            fontSize: 12,
            fontWeight: 500,
            color: isOverdue ? "#d32f2f" : "#2e7d32",
          }}
        >
          {isOverdue ? "⚠ Overdue: " : "🔁 Follow Up: "}
          {dayjs(log.next_follow_up_date).format("MMM D, YYYY")}
        </Box>
      )}
    </Box>
  </TimelineContent>

  {/* CENTER DOT */}
  <TimelineSeparator>
    <TimelineDot
      sx={{
        width: 12,
        height: 12,
        boxShadow: "none",
        bgcolor:
          log.call_outcome === "converted"
            ? "#4caf50"
            : "#1976d2",
      }}
    />
    {index !== callSummaryLog.length - 1 && (
      <TimelineConnector sx={{ bgcolor: "grey.300" }} />
    )}
  </TimelineSeparator>

  {/* RIGHT SIDE - DATE */}
  <TimelineOppositeContent
    sx={{
      m: 0,
      fontSize: 14,
      color: "text.secondary",
      display: "flex",
      // alignItems: "center",
      justifyContent: "flex-start",
      minWidth: 120,
    }}
  >
    {log.call_date
      ? dayjs(log.call_date).format("MMM D, YYYY")
      : "-"}
  </TimelineOppositeContent>
</TimelineItem>

      );
    })}
  </Timeline>
) : (
  <Grid item xs={12}>
    <Box sx={{ py: 4, textAlign: "center" }}>
      <Typography color="text.secondary">
        No Call History Available
      </Typography>
    </Box>
  </Grid>
)}



                        

                        
                         

                       
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            
                
                {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ padding: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Box className={classes.editButtonProfileBox}>
                              <ShoppingBasketIcon sx={{ fontSize: 32 }} />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            pt={2}
                            alignContent={"center"}
                            textAlign={"center"}
                          >
                            <Typography className={classes.h3}>$24</Typography>
                            <Typography className={classes.buttonLabel}>
                              Total Order
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ padding: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Box className={classes.editButtonProfileBox}>
                              <ShoppingBasketIcon sx={{ fontSize: 32 }} />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            pt={2}
                            alignContent={"center"}
                            textAlign={"center"}
                          >
                            <Typography className={classes.h3}>$2500</Typography>
                            <Typography className={classes.buttonLabel}>
                              Cost
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ padding: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Box className={classes.editButtonProfileBox}>
                              <ShoppingBasketIcon sx={{ fontSize: 32 }} />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            pt={2}
                            alignContent={"center"}
                            textAlign={"center"}
                          >
                            <Typography className={classes.h3}>$03</Typography>
                            <Typography className={classes.buttonLabel}>
                              Due
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ padding: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Box className={classes.editButtonProfileBox}>
                              <ShoppingBasketIcon sx={{ fontSize: 32 }} />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            pt={2}
                            alignContent={"center"}
                            textAlign={"center"}
                          >
                            <Typography className={classes.h3}>$5000</Typography>
                            <Typography className={classes.buttonLabel}>
                              Cost
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid> */}

        

        </>

      }


{showInvoice && (

<Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={4}
                        md={4}
                        sm={4}
                        xs={4}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Invoices
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={8}
                        md={8}
                        sm={8}
                        xs={8}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <TextField
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CiSearch
                                      className={classes.searchWidgetIcon} />
                                  </InputAdornment>
                                ),
                                classes: {
                                  root: classes.formControlList,
                                },
                              }}
                              fullWidth
                              value={searchQueryInvoice}
                              onChange={(e) => setSearchQueryInvoice(e.target.value)}
                              placeholder="Name .."
                              sx={{ width: "100%" }}
                              size="small" />
                          </Grid>

                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={() => navigate(
                                `/invoice/create/customer/${project.customer_id}/project/${projectId}`
                              )}
                            >
                              Add Invoice
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                            <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox"
                    onChange={handleSelectAllRows}
                    checked={selectedRows.length === invoiceList.length}
                  />
                </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Invoice No</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Status</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Amount</strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong>Create Date</strong>
                              </TableCell>
                            
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "right" }}
                              >
                                <strong>Actions</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceList.map((transaction) =>  {
                                const statusLabel = getStatusLabel(transaction.quoteWorkOrderStatus);
                                const statusColor = getStatusColor(transaction.quoteWorkOrderStatus);
                                return(

                                
                              <TableRow
                                key={transaction.id}
                                className={classes.tableRowHover}
                              >

                               <TableCell component="th"
                                  scope="row"
                                  className={classes.tablCell}>
                    
                  
                             <CustomCheckbox name="checkbox" 
                        checked={selectedRows.includes(transaction.id)}
                        onChange={() => handleSelectRow(transaction.id)}
                      />
                        </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {transaction.InvoiceNo}
                                </TableCell>
                                 <TableCell scope="row" className={classes.tablCell}>
                                                                                        <Button
                                                                         className={classes.statusButtonList}
                                                                     style={{
                                                                      color: statusColor,
                                                                   backgroundColor: transaction.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                                   ? "#e1f8d5"
                                                                    : transaction.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                                  ? "#f8d7da"
                                                               : transaction.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                               ? "lightyellow"
                                                              : transaction.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                             ? "#e2fafa"
                                                              : "#ffffff", // Fallback for other statuses
                                                              border: "solid 1px",
                                                              borderColor: statusColor,
                                                                borderRadius: "8px",
                                                                                                                      
                                                            }}
                                                       >
                                                         {statusLabel}
                                                           </Button>
                                                         </TableCell>

                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {"$"}
                                  {parseFloat(
                                    transaction?.quoteWorkOrderSaleGrandTotal || "0"
                                  ).toFixed(2)}
                                </TableCell>
                                <TableCell scope="row" className={classes.tablCell}>
                                  {transaction?.created_at
                                    ? dayjs(transaction.created_at).format(
                                      "MMMM D, YYYY [at] h:mm A"
                                    )
                                    : ""}
                                </TableCell>
                               

                                <TableCell scope="row" className={classes.tablCell}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.viewButtonList}
                                        onClick={() => navigate(
                                          `/invoice/history/${transaction.id}`
                                        )}
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon} />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            )})}
                          </TableBody>
                        </Table>



                        {selectedRows.length > 0 && (
          <Button      variant="contained"
          className={classes.addButton} onClick={handleEmailDialogOpen}>
            Send Email
          </Button>
        )}

<div id="invoice-content" 
  style={{ display: 'none' }}
   >
  <ViewInvoice  invoiceId={invoiceId} type="email" />
  </div>

<Dialog open={showEmailDialog} onClose={handleEmailDialogClose} maxWidth="sm" fullWidth>
          <DialogTitle>Send Email
          <IconButton
      aria-label="close"
      onClick={handleEmailDialogClose}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
          </DialogTitle>
          <DialogContent>
               <Grid container spacing={1} p={"14px"}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         To
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              size="small"
              className={classes.textField}
              InputProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: 14,
                },
              }}
              value={invoiceEmailData.to}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, to: e.target.value })}
            />
              </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                         Select Template
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
<TextField
   size="small"
   rows={4}
   className={classes.textField}
   InputProps={{
     sx: {
       fontSize: 14,
     },
   }}
   InputLabelProps={{
     sx: {
       fontSize: 14,
     },
   }}
  select
  value={invoiceEmailData.template} // Use state value
 
  onChange={(event) => {
    const selectedTemplateId = event.target.value;

    // Find the selected template from the list
    const selectedTemplate = emailTemplateList.find(
      (template) => template.id === Number(selectedTemplateId)
    );

    if (selectedTemplate) {
      // Set the form fields for subject and message based on the selected template
      setInvoiceEmailData({
        ...invoiceEmailData,
        template: selectedTemplateId, // Update template
        subject: selectedTemplate.subject, // Set subject from the selected template
        message: selectedTemplate.message, // Set message from the selected template
      });
    } else {
      // Reset subject and message if "Select option" is chosen
      setInvoiceEmailData({
        ...invoiceEmailData,
        template: "", // Clear template selection
        subject: "", // Clear subject
        message: "", // Clear message
      });
    }
  }}
>
  <MenuItem value="">
    Select option
  </MenuItem>
  {emailTemplateList.map((template) => (
    <MenuItem key={template.id} value={template.id}>
      {template.template_name} {/* Display the name of the template */}
    </MenuItem>
  ))}
</TextField>
</Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Subject
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
             size="small"
             className={classes.textField}
             InputProps={{
               sx: {
                 fontSize: 14,
               },
             }}
             InputLabelProps={{
               sx: {
                 fontSize: 14,
               },
             }}
              value={invoiceEmailData.subject}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, subject: e.target.value })}
            />
            </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Message
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>

            <TextField
            size="small"
            className={classes.textField}
            InputProps={{
              sx: {
                fontSize: 14,
              },
            }}
            InputLabelProps={{
              sx: {
                fontSize: 14,
              },
            }}
              multiline
              rows={7}
              value={invoiceEmailData.message}
              onChange={(e) => setInvoiceEmailData({ ...invoiceEmailData, message: e.target.value })}
            />
            </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>

            <Typography variant="subtitle1" gutterBottom>
              Attachments: {selectedRows.length} invoices selected
            </Typography>
            </Grid>
            </Grid>
            </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>



          <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                    
            <Button   disabled={loading}   startIcon={<SaveAltIcon />} 
          className={classes.addButton} onClick={handleSendEmail} variant="contained">
            {loading ? <CircularProgress size={24} /> : "Send"}
            </Button>
            </Grid>
            </Grid>
            </Card>
            </Grid>
          </DialogActions>
        </Dialog>







                      </TableContainer>
                    </Grid>
                  </Card>
                </Grid>
)}


{showEmailForm && (


              <><Grid item lg={12} md={12} sm={12} xs={12}>
                <form onSubmit={emailFormik.handleSubmit}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Compose Email
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} p={"24px"}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  To
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                  placeholder="Enter Email"
                                  size="small"
                                  {...emailFormik.getFieldProps("to")}
                                  className={classes.textField}
                                  InputProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                  error={emailFormik.touched.to &&
                                    Boolean(emailFormik.errors.to)}
                                  helperText={emailFormik.touched.to &&
                                    emailFormik.errors.to} />
                              </Grid>
                            </Grid>
                          </Grid>


                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Subject
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TextField
                                  placeholder="Enter Subject"
                                  size="small"
                                  {...emailFormik.getFieldProps("subject")}
                                  className={classes.textField}
                                  InputProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }} />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Message
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <div
                                  style={{
                                    height: "210px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px", // Optional: Add some rounding to the corners
                                    overflow: "hidden", // Prevent content overflow
                                  }}
                                >
                                  <ReactQuill
                                    value={emailFormik.values.message}
                                    onChange={(value) => emailFormik.setFieldValue("message", value)}
                                    style={{
                                      height: "210px",
                                    }} />

                                </div>


                              </Grid>
                            </Grid>
                          </Grid>


                          <Grid item lg={10} md={12} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">Select Template</Typography>
                              </Grid>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <TextField
                                  select
                                  size="small"
                                  className={classes.textField}
                                  SelectProps={{
                                    native: false,
                                  }}
                                  defaultValue=""
                                  value={emailFormik.values.template}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(event) => {
                                    const selectedTemplateId = event.target.value;

                                    const selectedTemplate = emailTemplateList.find(template => template.id === Number(selectedTemplateId));

                                    if (selectedTemplate) {
                                      // Set the form fields for subject and message based on the selected template
                                      emailFormik.setFieldValue("subject", selectedTemplate.subject);
                                      emailFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.message));
                                    } else {
                                      // Reset the subject and message if "Select an option" is chosen
                                      emailFormik.setFieldValue("subject", "");
                                      emailFormik.setFieldValue("message", "");
                                    }
                                    // Set the selected template value
                                    emailFormik.setFieldValue("template", selectedTemplateId);
                                  } }
                                >
                                  <MenuItem value="Select option">
                                    Select option
                                  </MenuItem>

                                  {emailTemplateList.map((template) => (
                                    <MenuItem key={template.id} value={template.id}>
                                      {template.template_name} {/* Display the name of the template */}
                                    </MenuItem>
                                  ))}

                                </TextField>
                              </Grid>
                            </Grid>
                          </Grid>



                        </Grid>
                      </Card>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                      <Card className={classes.card}>
                        <Grid container spacing={3} p={"24px"}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                            <Button
                              variant="contained"
                              startIcon={<SaveAltIcon />}
                              className={classes.addButton}
                              onClick={() => emailFormik.handleSubmit()}
                              disabled={!emailFormValid || isEmailSending}
                            >
                              Send
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </form>
              </Grid><Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Card className={classes.stepperCard}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={5}
                              sx={{ borderBottom: 2, padding: 2 }}
                              className={classes.titleGrid}
                            >
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography className={classes.cardTitle}>
                                  Call Summary History
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>


                          {callSummaryLog && callSummaryLog.length > 0 ? (
                            <Timeline
                              position="right"
                              sx={{
                                px: 2,
                                "& .MuiTimelineItem-root:before": {
                                  flex: 0,
                                  padding: 0,
                                },
                              }}
                            >
                              {callSummaryLog.map((log, index) => {
                                const isOverdue = log.next_follow_up_date &&
                                  dayjs(log.next_follow_up_date).isBefore(dayjs(), "day");

                                return (
                                  <TimelineItem
                                    key={log.id || index}
                                  >
                                    {/* LEFT SIDE - CONTENT */}
                                    <TimelineContent sx={{ py: 1 }}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          borderRadius: 2,
                                          backgroundColor: "#fff",
                                          border: "1px solid rgba(0,0,0,0.06)",
                                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                          transition: "0.2s",
                                          "&:hover": {
                                            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                          },
                                        }}
                                      >
                                        {/* Top Row */}
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 0.5,
                                          }}
                                        >
                                          <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                                            {capitalizeWords(log.call_outcome) || "-"}
                                          </Typography>

                                          <Box
                                            sx={{
                                              px: 1.5,
                                              py: 0.3,
                                              borderRadius: "12px",
                                              fontSize: 11,
                                              fontWeight: 600,
                                              background: log.priority === "high"
                                                ? "rgba(244,67,54,0.12)"
                                                : "rgba(25,118,210,0.12)",
                                              color: log.priority === "high"
                                                ? "#d32f2f"
                                                : "#1976d2",
                                            }}
                                          >
                                            {log.priority?.toUpperCase() || "NORMAL"}
                                          </Box>
                                        </Box>

                                        <Typography
                                          variant="body2"
                                          sx={{ color: "text.secondary", fontSize: 13 }}
                                        >
                                          {log.notes || "-"}
                                        </Typography>

                                        {log.next_follow_up_date && (
                                          <Box
                                            sx={{
                                              mt: 1,
                                              fontSize: 12,
                                              fontWeight: 500,
                                              color: isOverdue ? "#d32f2f" : "#2e7d32",
                                            }}
                                          >
                                            {isOverdue ? "⚠ Overdue: " : "🔁 Follow Up: "}
                                            {dayjs(log.next_follow_up_date).format("MMM D, YYYY")}
                                          </Box>
                                        )}
                                      </Box>
                                    </TimelineContent>

                                    {/* CENTER DOT */}
                                    <TimelineSeparator>
                                      <TimelineDot
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          boxShadow: "none",
                                          bgcolor: log.call_outcome === "converted"
                                            ? "#4caf50"
                                            : "#1976d2",
                                        }} />
                                      {index !== callSummaryLog.length - 1 && (
                                        <TimelineConnector sx={{ bgcolor: "grey.300" }} />
                                      )}
                                    </TimelineSeparator>

                                    {/* RIGHT SIDE - DATE */}
                                    <TimelineOppositeContent
                                      sx={{
                                        m: 0,
                                        fontSize: 14,
                                        color: "text.secondary",
                                        display: "flex",
                                        // alignItems: "center",
                                        justifyContent: "flex-start",
                                        minWidth: 120,
                                      }}
                                    >
                                      {log.call_date
                                        ? dayjs(log.call_date).format("MMM D, YYYY")
                                        : "-"}
                                    </TimelineOppositeContent>
                                  </TimelineItem>

                                );
                              })}
                            </Timeline>
                          ) : (
                            <Grid item xs={12}>
                              <Box sx={{ py: 4, textAlign: "center" }}>
                                <Typography color="text.secondary">
                                  No Call History Available
                                </Typography>
                              </Box>
                            </Grid>
                          )}









                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid></>

        )}


        {showCallForm && (

<>
<Grid item lg={12} md={12} sm={12} xs={12}>
          <form onSubmit={emailFormik.handleSubmit}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                       Call Summary
                      </Typography>
                    </Grid>
                  </Grid>



                  <Grid container spacing={3} p={"24px"}>


 
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Typography variant="subtitle1">Date</Typography>
              <TextField
                type="date"
                size="small"
                fullWidth
                defaultValue={dayjs().format("YYYY-MM-DD")} // today by default
                {...callFormik.getFieldProps("call_date")}
                InputLabelProps={{ shrink: true }}
                className={classes.textField}
              />
            </Grid>



                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                             Notes 
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
    multiline
    rows={3}
    size="small"
    fullWidth
    placeholder="Enter call notes"
    {...callFormik.getFieldProps("notes")}
    className={classes.textField}
  />
                        </Grid>
                      </Grid>
                    </Grid>


                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Call Outcome <span style={{ color: "red" }}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                        {["interested", "not_interested", "call_later", "converted"].map((item) => (
    <Button
      key={item}
      variant={callFormik.values.call_outcome === item ? "contained" : "outlined"}
      sx={{ 
        mr: 1, 
        mb: 1,
        textTransform: "none"  // <-- prevents uppercase
      }}
      onClick={() => callFormik.setFieldValue("call_outcome", item)}
    >
      {capitalizeWords(item).replace("_", " ")}
    </Button>
  ))}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Priority
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                      {["high", "medium", "low"].map((item) => (
    <Button
      key={item}
      variant={callFormik.values.priority === item ? "contained" : "outlined"}
      sx={{ 
        mr: 1, 
        mb: 1,
        textTransform: "none"  // <-- prevents uppercase
      }}
      onClick={() => callFormik.setFieldValue("priority", item)}
    >
      {capitalizeWords(item)}
    </Button>
  ))}

   
                        </Grid>
                      </Grid>
                    </Grid>
{["interested", "call_later"].includes(callFormik.values.call_outcome) && (
                     <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Next Follow-up Date <span style={{ color: "red" }}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
    type="date"
    size="small"
    fullWidth
    InputLabelProps={{ shrink: true }}
    {...callFormik.getFieldProps("next_follow_up_date")}
    className={classes.textField}
  />
   
                        </Grid>
                      </Grid>
                    </Grid>
)}


  <Grid item lg={6} md={6} sm={12} xs={12}>
              <Typography variant="subtitle1">Assign To</Typography>
              <TextField
                select
                size="small"
                fullWidth
                {...callFormik.getFieldProps("assigned_to")}
                className={classes.textField}
              >
                <MenuItem value="">Select Sales User</MenuItem>
                {driverList.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.driverFirstName} {user.driverLastName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>


                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                    
                      <Button
                        variant="contained"
                        startIcon={<SaveAltIcon />}
                        className={classes.addButton}
                        onClick={() => callFormik.handleSubmit()}
                        disabled={!callFormValid || isCallSending}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Grid>



  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                <Card className={classes.stepperCard}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={8}
                              md={8}
                              sm={8}
                              xs={8}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                                Call Summary History
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                       
{callSummaryLog && callSummaryLog.length > 0 ? (
  <Timeline
    position="right"
    sx={{
      px: 2,
      "& .MuiTimelineItem-root:before": {
        flex: 0,
        padding: 0,
      },
    }}
  >
    {callSummaryLog.map((log, index) => {
      const isOverdue =
        log.next_follow_up_date &&
        dayjs(log.next_follow_up_date).isBefore(dayjs(), "day");

      return (
      <TimelineItem
  key={log.id || index}
  // sx={{
  //   alignItems: "center",
  // }}
>
  {/* LEFT SIDE - CONTENT */}
  <TimelineContent sx={{ py: 1 }}>
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: "#fff",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        transition: "0.2s",
        "&:hover": {
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* Top Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
          {capitalizeWords(log.call_outcome) || "-"}
        </Typography>

        <Box
          sx={{
            px: 1.5,
            py: 0.3,
            borderRadius: "12px",
            fontSize: 11,
            fontWeight: 600,
            background:
              log.priority === "high"
                ? "rgba(244,67,54,0.12)"
                : "rgba(25,118,210,0.12)",
            color:
              log.priority === "high"
                ? "#d32f2f"
                : "#1976d2",
          }}
        >
          {log.priority?.toUpperCase() || "NORMAL"}
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ color: "text.secondary", fontSize: 13 }}
      >
        {log.notes || "-"}
      </Typography>

      {log.next_follow_up_date && (
        <Box
          sx={{
            mt: 1,
            fontSize: 12,
            fontWeight: 500,
            color: isOverdue ? "#d32f2f" : "#2e7d32",
          }}
        >
          {isOverdue ? "⚠ Overdue: " : "🔁 Follow Up: "}
          {dayjs(log.next_follow_up_date).format("MMM D, YYYY")}
        </Box>
      )}
    </Box>
  </TimelineContent>

  {/* CENTER DOT */}
  <TimelineSeparator>
    <TimelineDot
      sx={{
        width: 12,
        height: 12,
        boxShadow: "none",
        bgcolor:
          log.call_outcome === "converted"
            ? "#4caf50"
            : "#1976d2",
      }}
    />
    {index !== callSummaryLog.length - 1 && (
      <TimelineConnector sx={{ bgcolor: "grey.300" }} />
    )}
  </TimelineSeparator>

  {/* RIGHT SIDE - DATE */}
  <TimelineOppositeContent
    sx={{
      m: 0,
      fontSize: 14,
      color: "text.secondary",
      display: "flex",
      // alignItems: "center",
      justifyContent: "flex-start",
      minWidth: 120,
    }}
  >
    {log.call_date
      ? dayjs(log.call_date).format("MMM D, YYYY")
      : "-"}
  </TimelineOppositeContent>
</TimelineItem>

      );
    })}
  </Timeline>
) : (
  <Grid item xs={12}>
    <Box sx={{ py: 4, textAlign: "center" }}>
      <Typography color="text.secondary">
        No Call History Available
      </Typography>
    </Box>
  </Grid>
)}



                        

                        
                         

                       
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            

<Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Call Summary History
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                {/* <TextField
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <CiSearch
                                          className={classes.searchWidgetIcon} />
                                      </InputAdornment>
                                    ),
                                    classes: {
                                      root: classes.formControlList,
                                    },
                                  }}
                                  fullWidth
                                  value={searchQueryProject}
                                  onChange={(e) => setSearchQueryProject(e.target.value)}
                                  placeholder="Name .."
                                  sx={{ width: "100%" }}
                                  size="small" /> */}
                              </Grid>

                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid>
                          <TableContainer>
                            <Table className={classes.table}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                <TableCell className={classes.tablheader}>
                                    <strong> Call Outcome</strong>
                                  </TableCell>

                                  
                                  <TableCell className={classes.tablheader}>
                                    <strong>Priority</strong>
                                  </TableCell>
                                 
                                  <TableCell className={classes.tablheader}>
                                    <strong>Next Follow-Up</strong>
                                  </TableCell>

                                   <TableCell className={classes.tablheader}>
                                    <strong>Notes</strong>
                                  </TableCell>

                               
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {callSummaryLog && callSummaryLog.length > 0 ? (
            callSummaryLog
            // .filter(log => log.project_id === null)
            .map((log) => (
              <TableRow key={log.id} className={classes.tableRowHover}>
              

                
                <TableCell className={classes.tablCell}>
                  {log.call_outcome || "-"}
                </TableCell>

                <TableCell className={classes.tablCell}>
                  {log.priority || "-"}
                </TableCell>

               <TableCell className={classes.tablCell}>
                  {log?.next_follow_up_date
                    ? dayjs(log.next_follow_up_date).format("MMM D, YYYY")
                    : "-"}
                </TableCell>

                  <TableCell className={classes.tablCell}>
                    <Tooltip
                      title={log.notes}
                      disableInteractive={!log.notes || log.notes.length <= 30}
                      enterTouchDelay={0}   // show immediately on touch
                    >
                      <Typography
                        sx={{
                          maxWidth: { xs: 120, sm: 200 },
                          display: '-webkit-box',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          cursor: log.notes && log.notes.length > 30 ? 'pointer' : 'default',
                        }}
                      >
                        {log.notes || "-"}
                      </Typography>
                    </Tooltip>
               
                </TableCell>

           

              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} className={classes.tablCell}>
                No Data found.
              </TableCell>
            </TableRow>
          )}
                              </TableBody>
                            </Table>
                          </TableContainer>

                        
                        </Grid>
                      </Card>
                    </Grid>
                    </>
        )}

{showTextForm && (
         <><Grid item lg={12} md={12} sm={12} xs={12}>
                <form onSubmit={textFormik.handleSubmit}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              New Message
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} p={"24px"}>


                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container alignItems="center">
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  Text Message
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <div
                                  style={{
                                    height: "210px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px", // Optional: Add some rounding to the corners
                                    overflow: "hidden", // Prevent content overflow
                                  }}
                                >
                                  <ReactQuill
                                    value={textFormik.values.message}
                                    onChange={(value) => textFormik.setFieldValue("message", value)}
                                    style={{
                                      height: "210px",
                                    }} />

                                </div>

                              </Grid>
                            </Grid>
                          </Grid>




                        </Grid>
                      </Card>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                      <Card className={classes.card}>
                        <Grid container spacing={3} p={"24px"}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                            <Button
                              variant="contained"
                              startIcon={<SaveAltIcon />}
                              className={classes.addButton}
                              onClick={() => textFormik.handleSubmit()}
                              disabled={!textFormValid || isTextSending}
                            >
                              Send
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </form>
              </Grid><Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Card className={classes.stepperCard}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={5}
                              sx={{ borderBottom: 2, padding: 2 }}
                              className={classes.titleGrid}
                            >
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography className={classes.cardTitle}>
                                  Call Summary History
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>


                          {callSummaryLog && callSummaryLog.length > 0 ? (
                            <Timeline
                              position="right"
                              sx={{
                                px: 2,
                                "& .MuiTimelineItem-root:before": {
                                  flex: 0,
                                  padding: 0,
                                },
                              }}
                            >
                              {callSummaryLog.map((log, index) => {
                                const isOverdue = log.next_follow_up_date &&
                                  dayjs(log.next_follow_up_date).isBefore(dayjs(), "day");

                                return (
                                  <TimelineItem
                                    key={log.id || index}
                                  >
                                    {/* LEFT SIDE - CONTENT */}
                                    <TimelineContent sx={{ py: 1 }}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          borderRadius: 2,
                                          backgroundColor: "#fff",
                                          border: "1px solid rgba(0,0,0,0.06)",
                                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                          transition: "0.2s",
                                          "&:hover": {
                                            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                          },
                                        }}
                                      >
                                        {/* Top Row */}
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 0.5,
                                          }}
                                        >
                                          <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                                            {capitalizeWords(log.call_outcome) || "-"}
                                          </Typography>

                                          <Box
                                            sx={{
                                              px: 1.5,
                                              py: 0.3,
                                              borderRadius: "12px",
                                              fontSize: 11,
                                              fontWeight: 600,
                                              background: log.priority === "high"
                                                ? "rgba(244,67,54,0.12)"
                                                : "rgba(25,118,210,0.12)",
                                              color: log.priority === "high"
                                                ? "#d32f2f"
                                                : "#1976d2",
                                            }}
                                          >
                                            {log.priority?.toUpperCase() || "NORMAL"}
                                          </Box>
                                        </Box>

                                        <Typography
                                          variant="body2"
                                          sx={{ color: "text.secondary", fontSize: 13 }}
                                        >
                                          {log.notes || "-"}
                                        </Typography>

                                        {log.next_follow_up_date && (
                                          <Box
                                            sx={{
                                              mt: 1,
                                              fontSize: 12,
                                              fontWeight: 500,
                                              color: isOverdue ? "#d32f2f" : "#2e7d32",
                                            }}
                                          >
                                            {isOverdue ? "⚠ Overdue: " : "🔁 Follow Up: "}
                                            {dayjs(log.next_follow_up_date).format("MMM D, YYYY")}
                                          </Box>
                                        )}
                                      </Box>
                                    </TimelineContent>

                                    {/* CENTER DOT */}
                                    <TimelineSeparator>
                                      <TimelineDot
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          boxShadow: "none",
                                          bgcolor: log.call_outcome === "converted"
                                            ? "#4caf50"
                                            : "#1976d2",
                                        }} />
                                      {index !== callSummaryLog.length - 1 && (
                                        <TimelineConnector sx={{ bgcolor: "grey.300" }} />
                                      )}
                                    </TimelineSeparator>

                                    {/* RIGHT SIDE - DATE */}
                                    <TimelineOppositeContent
                                      sx={{
                                        m: 0,
                                        fontSize: 14,
                                        color: "text.secondary",
                                        display: "flex",
                                        // alignItems: "center",
                                        justifyContent: "flex-start",
                                        minWidth: 120,
                                      }}
                                    >
                                      {log.call_date
                                        ? dayjs(log.call_date).format("MMM D, YYYY")
                                        : "-"}
                                    </TimelineOppositeContent>
                                  </TimelineItem>

                                );
                              })}
                            </Timeline>
                          ) : (
                            <Grid item xs={12}>
                              <Box sx={{ py: 4, textAlign: "center" }}>
                                <Typography color="text.secondary">
                                  No Call History Available
                                </Typography>
                              </Box>
                            </Grid>
                          )}




                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid></>

        )} 

     {showNoteForm && (
         <Grid item lg={12} md={12} sm={12} xs={12}>
         <form onSubmit={noteFormik.handleSubmit}>
           <Grid container>
             <Grid item lg={12} md={12} sm={12} xs={12}>
               <Card className={classes.card}>
                 <Grid
                   container
                   justifyContent={"space-between"}
                   spacing={5}
                   sx={{ borderBottom: 2, padding: 2 }}
                   className={classes.titleGrid}
                 >
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     pt={2}
                     alignContent={"center"}
                   >
                     <Typography className={classes.cardTitle}>
                      New Message
                     </Typography>
                   </Grid>
                 </Grid>

                 <Grid container spacing={3} p={"24px"}>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Subject
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <TextField
                           placeholder="Enter Subject"
                           size="small"
                           {...noteFormik.getFieldProps("subject")}
                           className={classes.textField}
                           InputProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                           InputLabelProps={{
                             sx: {
                               fontSize: 14,
                             },
                           }}
                          
                         />
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={12} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">
                           Note Message
                         </Typography>
                       </Grid>
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                       <div
       style={{
       height: "210px",
      border:  "1px solid #ccc", 
      borderRadius: "4px", // Optional: Add some rounding to the corners
       overflow: "hidden", // Prevent content overflow
     }}
   >
               <ReactQuill
                 value={noteFormik.values.message}
                 onChange={(value) => noteFormik.setFieldValue("message", value)}
                 style={{
                   height: "210px",
                 }}
               />
               
   </div>

  
                       </Grid>
                     </Grid>
                   </Grid>

                   <Grid item lg={10} md={12} sm={12} xs={12}>
          <Grid container alignItems="center">
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Typography variant="subtitle1">Send as Email</Typography>
              <Switch
                checked={isSendAsEmail}
                onChange={handleToggleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </Grid>
          </Grid>
        </Grid>
          {isSendAsEmail && (
                   <Grid item lg={10} md={12} sm={12} xs={12}>
                     <Grid container alignItems="center">
                       <Grid item lg={12} md={12} sm={12} xs={12}>
                         <Typography variant="subtitle1">Select Template</Typography>
                       </Grid>
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                         <TextField
                           select
                           size="small"
                           className={classes.textField}
                           SelectProps={{
                             native: false,
                           }}
                           defaultValue=""
                           InputLabelProps={{ shrink: true }}
                           onChange={(event) => {
                             const selectedTemplateId = event.target.value;
                           
                             const selectedTemplate = noteTemplateList.find(template => template.id === Number(selectedTemplateId));
                         
                             if (selectedTemplate) {
                               // Set the form fields for subject and message based on the selected template
                               noteFormik.setFieldValue("subject", selectedTemplate.subject);
                               noteFormik.setFieldValue("message", convertPlainTextToHTML(selectedTemplate.note_message));
                           }
                          
                            //  noteFormik.setFieldValue("template", selectedTemplateId);
                           }}
                         >
                           <MenuItem value="Select option" >
                             Select option
                           </MenuItem>
                         
       {noteTemplateList.map((template) => (
         <MenuItem key={template.id} value={template.id}>
           {template.note_title} {/* Display the name of the template */}
         </MenuItem>
       ))}
                         
                         </TextField>
                       </Grid>
                     </Grid>
                   </Grid>

)}

                 </Grid>
               </Card>
             </Grid>

             <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
               <Card className={classes.card}>
                 <Grid container spacing={3} p={"24px"}>
                   <Grid
                     item
                     lg={12}
                     md={12}
                     sm={12}
                     xs={12}
                     sx={{ display: "flex", justifyContent: "flex-end" }}
                   >
                   
                     <Button
                       variant="contained"
                       startIcon={<SaveAltIcon />}
                       className={classes.addButton}
                       onClick={() => noteFormik.handleSubmit()}
                       disabled={!noteFormValid || isNoteSaving ||isNoteEmailSaving}
                     >
                     { isSendAsEmail ?'Send' : 'Save'}
                     </Button>
                   </Grid>
                 </Grid>
               </Card>
             </Grid>
           </Grid>
         </form>
       </Grid>
        )}
  </Grid>
  </Grid>



        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.profileBottomSetUpSmall}
                    
                  >
                    <Grid className={classes.profileBottomDwon}>
                      {customerList ? (
                        customerList.customerImg ? (
                          <img
                          src={`${LARAVEL_API_URL}/${customerList.customerImg}`}
                            alt="Profile"
                            className={classes.profileImage}
                          />
                        ) : (
                          <Avatar className={classes.profileImage} />
                        )
                      ) : (
                        <Avatar className={classes.profileImage} />
                      )}
                    </Grid>

                    <Grid className={classes.profileDetails}>
                      <Typography
                        variant="h4"
                        className={classes.profileDetailItem}
                      >
                        {(customerList?.customerFirstName || "") +
                          " " +
                          (customerList?.customerLastName || "")}
                      </Typography>

                      <Typography
                        variant="body1"
                        className={classes.contactInfo}
                      >
                        <span className={classes.iconText}>
                          <PhoneIcon /> {customerList?.customerMobileNum}
                        </span>
                      </Typography>
                      <Typography
                        variant="body1"
                        className={classes.contactInfo}
                      >
                        <span className={classes.iconText}>
                          <EmailIcon /> {customerList?.customerEmail}
                        </span>
                      </Typography>
                      <Button
                        variant="outlined"
                        endIcon={<ArrowForwardIosIcon />}
                        className={classes.addButton}
                        onClick={() => navigate(-1)}
                        sx={{ mt: 2 }}
                      >
                        Back
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            

           {callSummaryLog && callSummaryLog.some((log) => log.user) && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
    <Grid container spacing={2}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard} sx={{ p: 2 }}>
          {/* Card Title */}
          {/* <Typography
            variant="h6"
            sx={{ mb: 2, fontWeight: 600, color: "text.primary" }}
          >
            Assigned To
          </Typography> */}

          <Grid container spacing={2}>
            {callSummaryLog
              .filter((log) => log.user) // only logs with assigned users
              .map((log) => (
            <Grid item xs={12} key={log.id}>
  <Box
    sx={{
      position: "relative", // IMPORTANT
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      p: 2,
      borderRadius: 3,
      background: "rgba(255,255,255,0.7)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      transition: "0.3s",
      "&:hover": {
        boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
        transform: "translateY(-2px)",
      },
    }}
  >

    {/* Floating Top Right Badge */}
    <Box
      sx={{
        position: "absolute",
        top: -10,
        right: 16,
        px: 2,
        py: 0.5,
        borderRadius: "20px",
        fontSize: "0.7rem",
        fontWeight: 600,
        background: "#1976d2",
        color: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      Assigned To
    </Box>

    {/* LEFT SECTION */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
      
      {log.user?.driverImg ? (
        <Avatar
          src={`${LARAVEL_API_URL}/${log.user.driverImg}`}
          sx={{
            width: 42,
            height: 42,
          //  border: "2px solid #1976d2",
          }}
        />
      ) : (
        <Avatar
          sx={{
            width: 42,
            height: 42,
            bgcolor: "#1976d2",
            fontSize: 14,
          }}
        >
          {log.user?.driverFirstName?.[0]}
        </Avatar>
      )}

      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, fontSize: "0.95rem" }}
        >
          {log.user?.driverFirstName} {log.user?.driverLastName}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: "text.secondary", fontSize: "0.8rem" }}
        >
          Assigned on{" "}
          {log.call_date
            ? dayjs(log.call_date).format("DD MMM YYYY")
            : "-"}
        </Typography>
      </Box>
    </Box>
  </Box>
</Grid>



              ))}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  </Grid>
)}



            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Activity History
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                        className={classes.titleGrid}
                      >
                        <Box
                          sx={{
                            height: "600px",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                          <div>
    {timeLineSteps.length === 0 ? (
      <p style={{ textAlign: "center", padding: "20px" }}>No activity history found</p>
    ) : (
                          <Stepper
                            orientation="vertical"
                            activeStep={timeLineSteps.length}
                          >
                            {timeLineSteps.map((step, index) => (
                              <Step key={step.label} completed>
                                <StepLabel>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Typography className={classes.h5}>
                                      {step.label}
                                      <Typography
                                        variant="subtitle1"
                                        className={classes.showMoreLink}
                                        onClick={() => toggleStepDetails(index)}
                                      >
                                        {expandedSteps.includes(index)
                                          ? "Show less"
                                          : "Show more"}
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                      >
                                        {/* {step.time} */}
                                      </Typography>
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                       style={{whiteSpace:'nowrap'}}
                                    >
                                       {moment(`${step.date} ${step.time}`).format("MMM DD, YYYY, hh:mm a")}
                                    </Typography>
                                  </Box>
                                </StepLabel>

                                {expandedSteps.includes(index) && (
                                  <Box sx={{ ml: 4, mt: 1 }}>
                                    <Typography>{step.description}</Typography>
                                  </Box>
                                )}
                              </Step>
                            ))}

                          
                          </Stepper>
                            )}
  </div>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Payment Information
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        alignContent={"left"}
                      >
                        <img
                          src="/path-to-your-card-image.png"
                          alt="Card"
                          // alt={row.productName.toLowerCase()}
                          className={classes.SelectImageTableBoxProject}
                        />
                      </Grid>
                      <Grid item lg={9} md={9} sm={12} xs={12} pt={2}>
                        <Typography variant="subtitle1">Master Card</Typography>
                        <Typography variant="subtitle1">
                          XXXX XXXX XXXX 0985
                        </Typography>
                        <Typography variant="subtitle1">
                          Card Holdr Name: User 1
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Subscriptions 
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      {transactions.map((transaction) => (
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          key={transaction.id}
                        >
                        

                          <Grid container spacing={1} sx={{ borderBottom: 0.5  }}>
                            <Grid item lg={5} md={5} sm={5} xs={5}
                              >
                              <Typography
                                variant="subtitle1"
                               
                              >
                                {transaction.transactionName}
                              </Typography>
                            </Grid>
                            <Grid item lg={7} md={7} sm={7} xs={7}>
                                <Typography
                                variant="subtitle1" >
                                {transaction?.transactionCollection}
                              </Typography>
                              <Typography
                                variant="subtitle1"
                              
                              >
                                {transaction?.created_at
                                  ? dayjs(transaction.created_at).format(
                                      "MMMM D, YYYY [at] h:mm A"
                                    )
                                  : ""}
                              </Typography>
                              
                              
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.addButton}
                              onClick={handleOpenAddTransaction}
                            >
                              Add Subscription
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>



                </Grid>
              </Card>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
      {/* {openAddTransaction && (
        <NewCustomerTransactionPopUp
          openModel={openAddTransaction}
          handleCloseDialog={handleCloseAddTransaction}
          data={transactionData}
          customerId={project.customerId}
          projectId={projectId}
        />
      )} */}
    </div>
  );
};

export default Index;
